import React, {
  FC,
  useEffect,
  useState,
  createRef,
  useLayoutEffect,
  useContext,
} from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import {
  EntityCardContainer,
  EntityCardTitle,
} from '../../../entity/components/EntityCardComponents';
import styles from './lawyer_description.module.scss';
import { LawyerContext } from '../LawyerContext';

export const LawyerDescription: FC = () => {
  const {
    lawyerInfos: { description },
  } = useContext(LawyerContext);
  const [isMoreClicked, setIsMoreClicked] = useState(true);
  const [displayToggler, setDisplayToggler] = useState(false);
  const wrapperRef = createRef<HTMLDivElement>();

  useEffect(() => {
    if (description) {
      window.dispatchEvent(
        new CustomEvent('createNav', {
          detail: 'professional-description',
        }),
      );
    }
  });

  useLayoutEffect(() => {
    if (wrapperRef.current) {
      const height = wrapperRef.current.offsetHeight;
      if (height > 276) {
        setIsMoreClicked(false);
        setDisplayToggler(true);
      }
    }
  }, []);

  const moreDescriptionClicked = () => {
    if (!displayToggler) {
      setDisplayToggler(true);
    }
    if (isMoreClicked) {
      doctrineAnalytics('Professional MoreDescriptionClicked', {
        action: 'show_less',
      });
    } else {
      doctrineAnalytics('Professional MoreDescriptionClicked', {
        action: 'show_more',
      });
    }
    setIsMoreClicked(previous => !previous);
  };

  if (!description) return null;

  return (
    <EntityCardContainer id="professional-description">
      <EntityCardTitle>
        <FormattedMessage id="app.pages.lawyer.description.title" />
      </EntityCardTitle>
      <div
        ref={wrapperRef}
        className={classNames(styles.block, !isMoreClicked && styles.more)}
      >
        <pre dangerouslySetInnerHTML={{ __html: description }} />
      </div>
      {displayToggler && (
        <span className={styles.button} onClick={moreDescriptionClicked}>
          {isMoreClicked ? (
            <FormattedMessage id="lawyer/page/LawyerDescription.tsx/1" />
          ) : (
            <FormattedMessage id="lawyer/page/LawyerDescription.tsx/2" />
          )}
        </span>
      )}
    </EntityCardContainer>
  );
};
